import React from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";

import { useAuth } from "../../contexts";
import { useFeatureFlags } from "../../hooks";

type RequireFeatureFlagProps = {
  flagName: string;
  children: React.ReactNode;
};

// Gates a route on a restaurant feature flag. Navigating directly to a
// gated route with the flag off (or the restaurant unknown) redirects to
// /admin instead of rendering the page.
export const RequireFeatureFlag: React.FC<RequireFeatureFlagProps> = ({ flagName, children }) => {
  const { authState } = useAuth();
  const restaurantId = authState.currentRestaurant?.id;
  const { loading, isEnabled } = useFeatureFlags(restaurantId);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 64 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!restaurantId || !isEnabled(flagName)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};
